import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  constructor(private restService: RestService) {}

  search(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('client/search', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('client/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('client/all', val_params);
  }

  get(val_id: number) {
    return this.restService.get('client/edit', val_id);
  }

  save(data: any) {
    return this.restService.save('client/save', data);
  }

  saveGuest(data: any) {
    return this.restService.save('client/save_guest', data);
  }

  updateSave(data: any) {
    return this.restService.save('client/update/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('client/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('client/delete', val_id);
  }
}
